import { DialogProps } from '@reach/dialog';
import { FC, useCallback, useState } from 'react';

type ModalProps = DialogProps & {
  onDismiss: () => void;
};

export function useModal<T>(
  Component: FC<T & ModalProps>,
  props: Omit<T & ModalProps, 'onDismiss'>
) {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  const modalProps = { ...props, onDismiss: close } as T & ModalProps;

  return {
    modal: isOpen ? <Component {...modalProps} /> : null,
    open,
    close,
  };
}
